(function ($) {
    $(function () {
        var cardClass = 'post-card';
        var dot = '.';

        var linkClass = cardClass + '__heading-link';
        var cardClassLinked = cardClass + '--linked';

        // For keyboard and screen reader accessibility, only the card heading
        // is linked. This script allows the whole card to be clicked to follow
        // the link in the heading.
        $(dot + cardClass).each(function (cardIndex, cardNode) {
            var card = $(cardNode);
            var link = card.find(dot + linkClass);

            if (link.length === 0) {
                return;
            }

            var url = link.attr('href');

            card.on('click', function () {
                window.location.href = url;
            });

            card.addClass(cardClassLinked);
        });
    });
})(jQuery);
